<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.relationship">
  <app-popup-header title="{{localService.languageContent.relationship.header}}"></app-popup-header>
  <div class="modal-body modal-body-no-flexible-height">
    <ngx-select *ngIf="roles" [(ngModel)]="enumId" [optionValueField]="'key'" [optionTextField]="'value'" [items]="roles" [noAutoComplete]="true">
    </ngx-select>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
